import {useEffect} from 'react';

// import {useSelector} from 'react-redux';
import themeStyle from '../consts/themeStyle';
// import storageService from '../services/storageService';
import themeService from '../services/themeService';
// import {selectIsUseSystemTheme} from '../state/selectors/global';
// import {setIsUseSystemTheme} from '../state/slice/global';
// import {dispatch, getState} from '../state/store';

// Light mode disabled — always force dark mode
const useInitializeTheme = () => {
    // const isUseSystemTheme = useSelector(selectIsUseSystemTheme);

    useEffect(() => {
        themeService.applyTheme(themeStyle.DARK); // Temporary

        // const storedTheme = storageService.getThemeFromLocalStorage();
        //
        // if (storedTheme) {
        //     themeService.applyTheme(storedTheme);
        //     dispatch(setIsUseSystemTheme(false));
        // }
    }, []);

    // Initial theme setup and reacting to system theme changes
    // useEffect(() => {
    //     const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    //
    //     // Function to update the theme based on system preference
    //     const handleSystemThemeChange = (event) => {
    //         const currentIsUseSystemTheme = selectIsUseSystemTheme(getState());
    //
    //         if (currentIsUseSystemTheme) {
    //             const systemTheme = event.matches ? themeStyle.DARK : themeStyle.LIGHT;
    //
    //             themeService.applyTheme(systemTheme);
    //         }
    //     };
    //
    //     handleSystemThemeChange(mediaQuery);
    //
    //     mediaQuery.addEventListener('change', handleSystemThemeChange);
    //
    //     return () => {
    //         mediaQuery.removeEventListener('change', handleSystemThemeChange);
    //     };
    // }, [isUseSystemTheme]);
};

export default useInitializeTheme;
